import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../cell-validators'
import { getShipmentDisplayCalculated } from '../entities/shipment/get-shipment-display-calculated'

export const validateProfitPerHour: CellValidator = (record, token: GlobalToken) => {
    const profitPerHour = getShipmentDisplayCalculated(record)?.profitPerHour

    if (profitPerHour === undefined) {
        return null
    }

    if (profitPerHour < 15000) {
        return {
            message: 'Прибыль в час менее 15 000',
            color: token.colorErrorText || token.colorError,
        }
    }

    if (profitPerHour < 30000) {
        return {
            message: 'Прибыль в час от 15 000 до 30 000',
            color: token.colorWarningText || token.colorWarning,
        }
    }

    return {
        message: 'Прибыль в час 30 000 и более',
        color: token.colorSuccessText || token.colorSuccess,
    }
}
